import React from "react";
import {Box, Modal, Spinner} from "@nike/eds";

interface ManualClearingLoadingModalProps {
    isOpen: boolean;
    onDismiss: () => void;
}

function ManualClearingLoadingModal({isOpen, onDismiss}: ManualClearingLoadingModalProps) {
    return (
        <Modal
            isOpen={isOpen}
            onDismiss={onDismiss}
            headerSlot="Loading"
        >
            <div className="eds-grid eds-grid--m-cols-1">
                <Box className="eds-grid--col-full eds-grid--items-justify-center">
                    <Spinner size="large"/>
                </Box>
            </div>


        </Modal>
    );
}

export default ManualClearingLoadingModal;
